<div class="p-6">
 <div id="audio-player-container" class="flex justify-center mb-1">
    <button
      (click)="toggleRecording()"
      [ngClass]="isRecording ? 'bg-red-500 hover:bg-red-600' : 'bg-green-600 hover:bg-green-700'"
      class="px-4 py-2 text-white rounded-lg flex items-center gap-2 transition-colors duration-300"
      [attr.aria-label]="isRecording ? 'Stop Recording' : 'Start Recording'"
    >
      <span class="text-xl">
        <fa-icon [icon]="isRecording ? faPause : faPlay"></fa-icon>
      </span>
      {{ isRecording ? 'Stop Recording' : 'Start Recording' }}
    </button>
  </div>
  @if (isRecording) {
    <mat-progress-bar mode="determinate" [value]="((record_max_seconds - count) / record_max_seconds) * 100"></mat-progress-bar>
  }
</div>
